import toast from "react-hot-toast";

const server = process.env.REACT_APP_SERVER_URL || "";

export const createAtmosphere = {
  add: async (formData: any) => {
    try {
      const { designation } = formData;

      const response = await fetch(`${server}/api/atmospheres`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token") ?? ""}`,
        },
        body: JSON.stringify({ designation }),
      });
      const data = await response.json();
      if (response.ok) {
        toast.success(data.msg);
        return data;
      } else {
        toast.error(data.error);
        throw new Error(response.statusText);
      }
    } catch (error) {
      // Log error to monitoring service in production
      throw error;
    }
  },

  verify: async () => {
    try {
      const response = await fetch(`${server}/api/atmospheres`);
      if (!response.ok) {
        throw new Error("Failed to fetch atmosphere");
      }
      const json = await response.json();
      return json;
    } catch (error) {
      // Log error to monitoring service in production
      throw error;
    }
  },
  edit: async (data: any, id: any) => {
    try {
      const { designation } = data;

      const response = await fetch(`${server}/api/admin/atmospheres/${id}`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token") ?? ""}`,
        },
        body: JSON.stringify({ designation }),
      });
      const res = await response.json();

      if (response.ok) {
        toast.success(res.msg);
        return res;
      } else {
        toast.error(res.error);
        throw new Error(response.statusText);
      }
    } catch (error) {
      // Log error to monitoring service in production
      throw error;
    }
  },
  delete: async (id: number) => {
    try {
      const response = await fetch(`${server}/api/admin/atmospheres/${id}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token") ?? ""}`,
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || "An error occurred while deleting atmosphrere .");
      }
      const res = await response.json();
      toast.success(res.message);
    } catch (error) {
      // Log error to monitoring service in production
      // if (error instanceof Error) {
      //   toast.error(error.message);
      // } else {
      //   toast.error("An unexpected error occurred.");
      // }
      throw new Error("Error deleting atmosphrere.");
    }
  },
  getById: async (id: number) => {
    try {
      const response = await fetch(`${server}/api/atmospheres/${id}`, {
        method: "GET",
      });

      if (!response.ok) {
        throw new Error("Failed to delete category");
      }

      const data = await response.json();
      return data;
    } catch (error) {
      // Log error to monitoring service in production
    }
  },

  adminGetAllAtmospheres: async (page = 1, searchTerm = "") => {
    const query = new URLSearchParams({ page: page.toString() });
    if (searchTerm) {
      query.append("searchTerm", searchTerm);
    }

    const result = await fetch(`${server}/api/admin/atmospheres?${query.toString()}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token") ?? ""}`,
      },
    });

    return result.json();
  },
};
